module.exports = {
  returnNameForName: {
    Contratante: 'ContratanteRoot',
    'Grupo ou Complemento': 'GrupoRoot',
  },
  returnNameUIForNameAPI: {
    ContratanteRoot: 'Contratante',
    GrupoRoot: 'Grupo ou Complemento',
  },
  returnName: {
    0: 'Contratante',
    1: 'Grupo ou Complemento',
  },
  returnNameAPI: {
    0: 'ContratanteRoot',
    1: 'GrupoRoot',
  },
};
